import { CSSObject } from '@emotion/core'

const frontTabletMedia = {
  // 横向き11inch。13inch用の条件と重ならないよう上限を持たせる。
  landscape11: '@media (orientation: landscape) and (max-width: 1279px)',
  portrait: '@media (orientation: portrait)',
  // 横向き11inch（1180px）と13inch（1366px）を1280pxで分ける。
  landscape13: '@media (orientation: landscape) and (min-width: 1280px)',
} as const

type FrontTabletProfile = keyof typeof frontTabletMedia

/**
 * 現在はセルフチェックインだけがレスポンシブ対応済みであるため、共有コンポーネントのCSSを
 * セルフチェックアウトの従来表示から分離する目的で、selfCheckinResponsiveScope を付与し、このスコープ内のみでレスポンシブCSSを適用する。
 */
const selfCheckinResponsiveScope = '[data-self-checkin-responsive="true"] &'

// landscape11/landscape13は端末幅で値を分けるが、portraitは縦向き全般に適用する。
export const FrontTabletResponsiveToken = {
  headerHeight: { landscape11: 80, portrait: 80, landscape13: 86 },
  headingFontSize: { landscape11: 20, portrait: 20, landscape13: 24 },
  bodyFontSize: { landscape11: 18, portrait: 18, landscape13: 22 },
  formLabelFontSize: { landscape11: 20, portrait: 20, landscape13: 24 },
  formInputFontSize: { landscape11: 22, portrait: 22, landscape13: 26 },
  standardButtonFontSize: { landscape11: 22, portrait: 22, landscape13: 24 },
  guestFormTitleFontSize: { landscape11: 22, portrait: 22, landscape13: 26 },
  editSectionTitleFontSize: { landscape11: 22, portrait: 22, landscape13: 26 },
} as const

type SelfCheckinResponsiveStyles = Partial<Record<FrontTabletProfile, CSSObject>>
const frontTabletProfiles: FrontTabletProfile[] = ['landscape11', 'portrait', 'landscape13']

/** セルフCI/COで共有しているコンポーネントで、セルフCIにのみ適用したい、全画面サイズで共通するCSSを適用する。 */
export const createSelfCheckinBaseStyle = (style: CSSObject): CSSObject => ({
  [selfCheckinResponsiveScope]: style,
})

/**
 * セルフCI配下だけに、指定された画面サイズごとのCSSを適用する
 * セルフCI/COで共有しているコンポーネントで、セルフCIにのみ適用される全サイズ共通値にはcreateSelfCheckinBaseStyleを使用する
 * セルフチェックイン専用コンポーネントの全サイズ共通値は通常CSSに定義する
 */
export const createSelfCheckinResponsiveStyle = (styles: SelfCheckinResponsiveStyles): CSSObject => {
  const responsiveStyles: CSSObject = {}

  frontTabletProfiles.forEach(profile => {
    const style = styles[profile]
    if (style) responsiveStyles[frontTabletMedia[profile]] = style
  })

  return { [selfCheckinResponsiveScope]: responsiveStyles }
}
